import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { Result } from "antd";
import { FormattedMessage } from "react-intl";
import TopbarView from "./template/topbar";
import AppContext from "../AppContext";

class TestPage extends Component {
  static contextType = AppContext;

  render() {
    return (
      <TopbarView layout>
        <Result status="warning" title={<FormattedMessage id={"Page Not Found"} />} />
      </TopbarView>
    );
  }
}

export default injectIntl(TestPage);